import { render, staticRenderFns } from "./SalidaTrasladoFormComponent.vue?vue&type=template&id=454e2700&"
import script from "./SalidaTrasladoFormComponent.vue?vue&type=script&lang=js&"
export * from "./SalidaTrasladoFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports